import type { ReactNode } from 'react';
import { Icon } from '../icon/icon.component';
import { OutlineCard } from '../outline-card/outline-card.component';
import { type Style, mergeStyle } from './onboarding-slide.module.css';

interface Props {
  style?: Style;
  outlined?: boolean;
  index: number;
  selectedIndex: number;
  icon: string;
  title: string;
  description: string;
  children: ReactNode;
}

export function OnboardingSlide(props: Props) {

  const {
    style: customStyle,
    outlined = false,
    index,
    selectedIndex,
    icon,
    title,
    description,
    children
  } = props;

  const style = mergeStyle(customStyle);
  const Content = outlined ? OutlineCard : 'div';

  return (
    <section
      className={style.slide}
      aria-label={`${index + 1} de 4`}
      aria-roledescription='diapositiva'
      aria-hidden={selectedIndex !== index}>
      <Content className={style.content}>
        <div className={style.iconContainer}>
          <Icon icon={icon} className={style.heroIcon} variant='round'/>
        </div>
        <h1 className={style.title}>{title}</h1>
        <p className={style.description}>{description}</p>
        {children}
      </Content>
    </section>
  );
}
